import Tippy from '@tippyjs/react'
import { useEffect, useState } from 'react'
import styles from './SalaryChartSpread.module.scss'
import { formatSalary } from '../../libs/helpers/reportUtils'

interface IProps {
  min: number
  max: number
  p25: number
  p75: number
  lang: string
  tooltip: string
}
const SalaryChartSpread = ({ min, max, p25, p75, lang, tooltip }: IProps) => {
  const [trigger, setTrigger] = useState('mouseenter')

  useEffect(() => {
    setTrigger(window.innerWidth > 768 ? 'mouseenter' : 'click')
  }, [])

  return (
    <Tippy content={tooltip} placement='top' trigger={trigger}>
      <div
        className={`flex justify-between items-center ${styles['salary-chart']}`}
      >
        <div style={{ width: `${((p25 - min) / max) * 100}%` }} />
        <div className='px-2 md:px-8 flex flex-col items-center'>
          <div>{formatSalary(p25, lang)}</div>
          <div className='text-xxs font-thin'>p25</div>
        </div>
        <div className='h-5 w-full bg-yellow-200 rounded-full' />

        <div className='px-2 md:px-8 flex flex-col items-center'>
          <div>{formatSalary(p75, lang)}</div>
          <div className='text-xxs font-thin'>p75</div>
        </div>

        <div style={{ width: `${((max - p75) / max) * 100}%` }} />
      </div>
    </Tippy>
  )
}

export default SalaryChartSpread
